import ClipboardJS from "clipboard"

export default class SelfDriveRouteArticleController extends ApplicationController {
    connect() {
        const clipboard = new ClipboardJS(".clip-button", {
            text: (trigger) => {
                this._hideTooltip(trigger)
                return trigger.previousElementSibling.textContent
            }
        })

        document.querySelectorAll(".clip-button").forEach((button) => {
            button.addEventListener("mouseout", (event) => {
                this._hideTooltip(event.currentTarget)
            })
        })

        clipboard.on("success", (e) => {
            e.clearSelection()
            this._showTooltip(e.trigger, "已拷贝!")
        })

        clipboard.on("error", (e) => {
            this._showTooltip(e.trigger, "拷贝出错!")
        })
    }

    _hideTooltip(element) {
        element.firstChild.innerText = ""
        element.className = 'clip-button has-text-link fas fa-copy'
    }

    _showTooltip(element, message) {
        element.firstChild.innerText = message
        element.className = 'clip-button has-text-link fas fa-copy tooltipped'
    }
}